import { Injectable, Inject } from "@angular/core";
import { AppConfig } from "src/environments/appconfig";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { MaMiscelaneoDetalle } from "../dominio/miscelaneoDetalle";
import { UHttpsClient } from "src/app/seguridad/seguridad/uhttpsClient";

@Injectable()
export class MaMiscelaneosdetalleServicio {

    private url = `${this.config.getEnv('proxy')}spring/core/mamiscelaneosdetalle/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public listarPorCabecera(aplicacionCodigo: string, compania: string, codigoTabla: string): Promise<MaMiscelaneoDetalle[]> {

        const params = new HttpParams().set('aplicacionCodigo', aplicacionCodigo)
            .set('compania', compania)
            .set('codigoTabla', codigoTabla)  

        return this.http.get(`${this.url}listarPorCabecera`, { params ,  headers: this.headers })
            .toPromise()
            .then(response => {
                return response as MaMiscelaneoDetalle[];
            })
            .catch(error => []);
    }
}

